import React from "react";
import DefaultNavbar from "components/DefaultNavbar";
import DefaultFooter from "components/DefaultFooter";
import Title from "components/landing/Title";
import Eunice from "../assets/img/EuniceSoloStraight.jpg";
import Johnny from "../assets/img/JohnnySoloVertical.jpg";
import Service1 from "../assets/img/gallery/Service1.jpg";
import Service5 from "../assets/img/gallery/Service5.JPG";
import { JohnnyBio } from "assets/bios/bios";
import { EuniceBio } from "assets/bios/bios";

export default function About() {
  return (
    <>
      <DefaultNavbar />
      <main>
        {/* About Us - white */}
        <div className="pt-8 pb-16" style={{ backgroundColor: '#FFFFFF' }}>
          <div className="container max-w-7xl mx-auto px-4">
            <Title heading="About Us">
              <p style={{ fontSize: 22 }}>
                Rise Up Prison Ministry is birthed out of a burden that God has placed on our
                hearts to share the truth of the gospel of Jesus Christ with the incarcerated.
                While Jesus came first for the Jew, he consistently ministered to the broken,
                lost, and forgotten. Our mission is to share the love of Christ with those
                behind bars, while teaching the Word of God and allowing the Holy Spirit to
                do the work of salvation.
              </p>
            </Title>
          </div>
        </div>

        {/* Who Are We? - light gray */}
        <div className="py-16" style={{ backgroundColor: '#f8fafc' }}>
          <div className="container max-w-7xl mx-auto px-4">
            <Title heading="Who Are We?">
              <p style={{ fontSize: 22 }}>
                We are non-denominational in our doctrine but adhere to the Holy
                Bible as complete and inerrant Word of God, written by men
                inspired through the Holy Spirit. We believe that God is the
                eternal creator of all things and that He is Trinitarian in
                existence as the Father, the Son, and the Holy Spirit. We believe
                that salvation is by grace alone, through faith alone, in the
                life, death, and resurrection of Jesus, the Messiah; the Son of
                God who became flesh through a virgin birth. We believe that
                salvation is the work of the Holy Spirit to convict, call and seal
                us into that saving grace, and we also believe that the gifts of
                the spirit are for all generations and meant to be used for the
                edification of the Body of Christ. We believe that all have sinned
                and fall short of the glory of God (Romans3:23); that the wages of
                sin is death (Romans 6:23a); and that the gift of God is eternal
                life in Christ Jesus our Lord (Romans 6:23b). We also believe that
                salvation is active, not passive, and involves surrendering your
                will to God's will and making Jesus both Lord and Savior, and
                following Him as a disciple.
              </p>
            </Title>
          </div>
        </div>

        {/* Our Service - white */}
        <div className="py-16" style={{ backgroundColor: '#FFFFFF' }}>
          <div className="container max-w-7xl mx-auto px-4">
            <Title heading="Our Service">
              <p style={{ fontSize: 22 }}>
                Our typical service consists of worship, teaching the Word of God,
                exhortation and testimony, and prayer. We aim to bring truth that
                will allow the Holy Spirit to convict, draw hearts towards God,
                and grow in spiritual maturity. We also bring teaching that will
                instruct a believer to understand their identity in Christ, and
                how to utilize their faith to break strongholds in their lives,
                since "It is for freedom that Christ has set us free." Galatians
                5:1
              </p>
              <img
                src={Service1}
                alt="Our Service"
                className="mt-6 w-full lg:w-[130%] lg:relative lg:left-1/2 lg:-translate-x-1/2 rounded-lg shadow-lg"
              />
            </Title>
          </div>
        </div>

        {/* What We Do - light gray */}
        <div className="py-16" style={{ backgroundColor: '#f8fafc' }}>
          <div className="container max-w-7xl mx-auto px-4">
            <Title heading="What We Do">
              <p style={{ fontSize: 22 }}>
                We currently minister in 12 prisons across the state of Missouri.
                We have weekly services at three institutions, and the remainders
                are bi-monthly, monthly, or quarterly. We also work to coordinate
                and assist in special events such as yard-jams, offender food
                events, and concerts.
              </p>
              <div className="mt-6">
                <h3 className="text-2xl font-semibold text-gray-700 mb-4">
                  Prisons We Visit
                </h3>
                <div className="leading-relaxed">
                  <p><strong>Algoa Correctional Center</strong> — Friday Nights</p>
                  <p><strong>Jefferson City Correctional</strong> — Monday Evenings, 3rd Sunday Evenings</p>
                  <p><strong>Chillicothe Correctional</strong> — Tuesday Evenings, 4th Sunday Morning</p>
                  <p><strong>Tipton Correctional</strong> — 2nd, 4th, and 5th Wednesday Evenings</p>
                  <p><strong>Boonville Correctional</strong> — 1st and 3rd Sunday Afternoons</p>
                  <p><strong>Crossroads Correctional</strong> — Saturday Evenings (before 4th Sunday)</p>
                  <p><strong>South Central Correctional</strong> — Monday Morning (after 3rd Sunday)</p>
                  <p><strong>Fulton Reception and Diagnostics</strong> — 4th Thursday Evening</p>
                  <p><strong>Northeast Correctional</strong> — Saturday Afternoon (before 5th Sunday)</p>
                  <p><strong>Potosi Correctional</strong> — Saturday Evening (before 5th Sunday)</p>
                  <p><strong>Farmington Correctional</strong> — 5th Sunday (A-side Morning, B-side Afternoon)</p>
                </div>
                <img
                  src={Service5}
                  alt="Prisons we visit"
                  className="mt-6 w-full lg:w-[130%] lg:relative lg:left-1/2 lg:-translate-x-1/2 rounded-lg shadow-lg"
                />
              </div>
            </Title>
          </div>
        </div>

        {/* Eunice & Johnny - navy background */}
        <section style={{ backgroundColor: '#304c79', padding: '80px 0' }}>
          <div className="container max-w-7xl mx-auto px-4">
            <div className="flex flex-col lg:flex-row gap-12" style={{ alignItems: 'stretch' }}>
              <div className="flex-1">
                <div className="bg-white rounded-lg shadow-xl overflow-hidden">
                  <img
                    style={{ width: "100%", maxHeight: 500, objectFit: "contain", paddingTop: 16 }}
                    src={Eunice}
                    alt={"Eunice"}
                  />
                  <div className="p-6">
                    <h3 className="text-2xl font-semibold text-gray-700 mb-4 text-center">Eunice</h3>
                    <p style={{ fontSize: 18 }} className="text-gray-700 leading-relaxed">
                      {EuniceBio}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="bg-white rounded-lg shadow-xl overflow-hidden">
                  <img
                    style={{ width: "100%", maxHeight: 500, objectFit: "contain", paddingTop: 16 }}
                    src={Johnny}
                    alt={"Johnny"}
                  />
                  <div className="p-6">
                    <h3 className="text-2xl font-semibold text-gray-700 mb-4 text-center">Johnny</h3>
                    <p style={{ fontSize: 18 }} className="text-gray-700 leading-relaxed">
                      {JohnnyBio}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <DefaultFooter />
    </>
  );
}
